// src/utils/formatKcal.js
//
// Formato ÚNICO de calorias em toda a UI e nas imagens compartilháveis:
// inteiro, SEM separador de milhar e SEM til de estimativa.
//   1411.4 → "1411"   (não "1.411", não "~1411")
//
// Só kcal segue esta regra — peso, XP, distância e volume continuam com a
// formatação pt-BR normal. Aceita string com vírgula ("350,6") por causa dos
// campos de formulário.
export const formatKcal = (value) => {
  const normalized = typeof value === 'string' ? value.trim().replace(',', '.') : value;
  const n = Number(normalized);
  return Number.isFinite(n) ? String(Math.round(n)) : '0';
};

export const formatKcalLabel = (value) => `${formatKcal(value)} kcal`;

export default formatKcal;
